import { useState, useEffect } from 'react';
import api from '../api/api';

let _cache = null;
let _pending = null;

function fetchAll() {
  if (_pending) return _pending;
  _pending = api.get('/seo-settings').then(({ data }) => {
    _cache = data || {};
    _pending = null;
    return _cache;
  }).catch(() => {
    _cache = {};
    _pending = null;
    return {};
  });
  return _pending;
}

export function useSeoSettings(pageKey) {
  const [settings, setSettings] = useState(() => _cache?.[pageKey] || {});

  useEffect(() => {
    if (_cache) { setSettings(_cache[pageKey] || {}); return; }
    fetchAll().then(all => setSettings(all[pageKey] || {}));
  }, [pageKey]);

  return settings;
}

export function useAllSeoSettings() {
  const [all, setAll] = useState(() => _cache || {});

  useEffect(() => {
    if (_cache) { setAll(_cache); return; }
    fetchAll().then(data => setAll(data));
  }, []);

  return all;
}
